import { jsx as _jsx } from "react/jsx-runtime";
import { useDomain } from '../hooks/useDomain';
export const Image = ({ src, alt, ...rest }) => {
    const { subfolder } = useDomain();
    if (src.indexOf('/') === 0 && src.indexOf('//') !== 0)
        src = `${subfolder}${src}`;
    return _jsx("img", { src: src, alt: alt || '', ...rest }, void 0);
};
//# sourceMappingURL=Image.js.map